<div fxLayout="column">
  <app-page-header [section]="data.pageName"
                   [title]="pageHeader.title"
                   [description]="pageHeader.description"></app-page-header>

  <div class="page-padding page-content full-screen-height-page-default"
       fxLayout="column" [formGroup]="filterForm">
    <div fxLayout="row" fxLayoutAlign="space-evenly center" fxLayoutGap="10px">
      <span class="subtitle-default">Lease List</span>
      <div fxLayoutGap="10px" fxFlexOffset="30px">
        <button class="button-action" mat-flat-button (click)="openCreateLeaseTab()" [disabled]="loader.loading$ | async">
          <div class="button-text">Create a lease</div>
        </button>
      </div>
      <span class="fx-spacer"></span>
      @if (filterTypes.includes(LeaseFilterType.DATE_RANGE)) {
        <app-custom-date-filter [customDateRangePresets]="dateFilters"
                                (dateRange)="getDateRange($event)"
                                matTooltip="Filter by lease term">
        </app-custom-date-filter>
      }

      @if (filterTypes.includes(LeaseFilterType.COMPACT_VIEW)) {
        <mat-button-toggle-group [(value)]="tableViewMode" class="custom-date-button-toggle"
                                 (valueChange)="onTableViewModeChange()"
                                 hideSingleSelectionIndicator>
          <mat-button-toggle [value]="DefaultTableViewMode.COMPACT" matTooltip="Compact View">
            <mat-icon class="lease-schedule-table-column-toggle">view_column_2</mat-icon>
          </mat-button-toggle>
          <mat-button-toggle [value]="DefaultTableViewMode.FULL" matTooltip="Expanded View">
            <mat-icon>view_column</mat-icon>
          </mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="10px" fxFlexOffset="20px"
         class="fx-gap-20">
      @if (filterTypes.includes(LeaseFilterType.LEASE_STATUS)) {
        <mat-button-toggle-group formControlName="leaseStatus" multiple
                                 class="custom-labeled-button-toggle"
                                 hideMultipleSelectionIndicator>
          <mat-label>Lease Status</mat-label>
          @for (status of leaseStatuses; track status) {
            <mat-button-toggle [value]="status">{{ utils.displayStatus(status) }}</mat-button-toggle>
          }
        </mat-button-toggle-group>
      }

      @if (filterTypes.includes(LeaseFilterType.OCCUPANCY_TYPE)) {
        <mat-button-toggle-group formControlName="occupancyType" multiple
                                 class="custom-labeled-button-toggle"
                                 hideMultipleSelectionIndicator>
          <mat-label>Occupancy Type</mat-label>
          @for (type of occupancyTypes; track type) {
            <mat-button-toggle [value]="type">{{ utils.displayStatus(type) }}</mat-button-toggle>
          }
        </mat-button-toggle-group>
      }

      @if (filterTypes.includes(LeaseFilterType.TERM_STATUS)) {
        <mat-button-toggle-group formControlName="tradingOutsideOfLeasePeriod" multiple
                                 class="custom-labeled-button-toggle"
                                 hideMultipleSelectionIndicator>
          <mat-label>Term Status</mat-label>
          <mat-button-toggle [value]="false">In Term</mat-button-toggle>
          <mat-button-toggle [value]="true">Out of Term</mat-button-toggle>
        </mat-button-toggle-group>
      }

      @if (filterTypes.includes(LeaseFilterType.EXPIRES_IN)) {
        <mat-button-toggle-group formControlName="expiresIn" multiple
                                 class="custom-labeled-button-toggle"
                                 hideMultipleSelectionIndicator>
          <mat-label>Expires In</mat-label>
          <mat-button-toggle [value]="30">30 Days</mat-button-toggle>
          <mat-button-toggle [value]="60">60 Days</mat-button-toggle>
          <mat-button-toggle [value]="90">90 Days</mat-button-toggle>
        </mat-button-toggle-group>
      }
    </div>

    <div class="pr-10" fxLayout="row" fxLayoutAlign="end center" fxFlexOffset="20px">
      <span class="body-1-regular">Hint, to see more columns use the toolbar to switch between the compact and expanded view</span>
    </div>

    <div class="radius-10 mat-elevation-z3 bg-white" fxLayout="column" fxFlexOffset="10px">
      <app-crud-table title="Lease Schedule"
                      [tableData]="filteredLeaseData"
                      [loading$]="loader.loading$"
                      [modelType]="CrudLease"
                      [showColumns]="displayedColumns"
                      [maxPageSize]="pageSize"
                      [showLoadMore]="true"
                      (reloadData)="loadInitialLeaseData()"
                      (loadData)="loadMoreLeases()"
                      (rowSelected)="openLeaseViewTab($event)">
      </app-crud-table>
    </div>
  </div>

</div>
